import React from "react";

import { IColumnContext } from "./column-context.types";

export const defaultContext: IColumnContext = { isBody: true };

const ColumnContext = React.createContext<IColumnContext>(defaultContext);
export default ColumnContext;
